import React, { useState } from "react";
import "./Chatbot.css";

export default function Chatbot() {
  const [desktopOpen, setDesktopOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      {/* Desktop chatbot button */}
      <button
        className="sapiencia-desktop-chat-button"
        onClick={() => setDesktopOpen(true)}
        aria-label="Open Sapiencia AI Chat"
      >
        💬
      </button>

      {/* Desktop chatbot panel */}
      {desktopOpen && (
        <div className="sapiencia-desktop-chat-panel">
          <button
            className="sapiencia-desktop-chat-close"
            onClick={() => setDesktopOpen(false)}
            aria-label="Close Sapiencia AI Chat"
          >
            ×
          </button>

          <iframe
            src="https://chat.sapiencia.ai/widget?mode=inline"
            className="sapiencia-chatbot-desktop"
            allow="clipboard-write"
            title="Sapiencia AI Chat"
          />
        </div>
      )}

      {/* Mobile chatbot button */}
      <button
        className="sapiencia-mobile-chat-button"
        onClick={() => setMobileOpen(true)}
        aria-label="Open Sapiencia AI Chat"
      >
        💬
      </button>

      {/* Mobile chatbot panel */}
      {mobileOpen && (
        <div className="sapiencia-mobile-chat-panel">
          <button
            className="sapiencia-mobile-chat-close"
            onClick={() => setMobileOpen(false)}
            aria-label="Close Sapiencia AI Chat"
          >
            ×
          </button>

          <iframe
            src="https://chat.sapiencia.ai/widget?mode=inline"
            className="sapiencia-mobile-chat-frame"
            allow="clipboard-write"
            title="Sapiencia AI Chat Mobile"
          />
        </div>
      )}
    </>
  );
}